<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="selection"></ng-container>
            <tt-button-goto [ttText]="'travexptypes_new'" (ttClick)="goToFunc('travexptype')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
        </tt-card>

        <ng-container *ngTemplateOutlet="list"></ng-container>

        <tt-card>
            <tt-button-settings></tt-button-settings>
        </tt-card>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="h_selection_criteria">
                <ng-container *ngTemplateOutlet="selection"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="h_functions">
                <tt-button-goto [ttText]="'travexptypes_new'" (ttClick)="goToFunc('travexptype')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
                <tt-button-settings></tt-button-settings>
            </tt-card>
        </div>

        <div class="col-xs-12 col-md-6 p-5">
            <ng-container *ngTemplateOutlet="list"></ng-container>
        </div>
    </div>
</tt-page>

<ng-template #selection>
    <ng-container *ngIf="!!setting">
        <tt-select *ngIf="setting.businessco_no === '99999'" ttRememberId="w_travexptypes.businessco_no" ttLabel="businessco" [(ttModel)]="setting.businessco_no" (ttModelChange)="onChanged($event, 'businessco_no')" [ttData]="selectListCompanies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
        <tt-select *ngIf="setting.businessco_no !== '99999'" ttRememberId="w_travexptypes.businessco_no" ttLabel="businessco" [(ttModel)]="setting.businessco_no" (ttModelChange)="onChanged($event, 'businessco_no')" [ttData]="selectListCompanies" ttDataId="businessco_no" ttDataName="company_name" [ttButtons]="businessButtons"></tt-select>
        <tt-input ttRememberId="w_travexptypes.searchtext" ttLabel="searchtext" ttFocus="false" [(ttModel)]="setting.searchtext" ttShowClearButton></tt-input>
    </ng-container>
</ng-template>

<ng-template #list>
    <ng-container *ngIf="!!setting">
        <tt-list [ttData]="itemsListTravelExpenseTypes" [ttFilter]="setting.searchtext"></tt-list>
    </ng-container>
</ng-template>

<!--<tt-page class="col-xs-12 sp-0" ng-if="vm.model.tabletSize.matches === false">
    <tt-card class="col-xs-12 sp-0">
        <div ng-if="vm.model.setting.businessco_no === '99999'">
            <tt-select class="col-xs-12 sp-0" tt-label="businessco" tt-model="vm.model.setting.businessco_no" tt-change="vm.onChanged($value, 'businessco_no')" tt-data="vm.model.selectListCompanies" tt-data-id="businessco_no" tt-data-name="company_name"></tt-select>
        </div>

        <div ng-if="vm.model.setting.businessco_no !== '99999'">
            <tt-select-buttons class="col-xs-12 sp-0" tt-label="businessco" tt-model="vm.model.setting.businessco_no" tt-change="vm.onChanged($value, 'businessco_no')" tt-data="vm.model.selectListCompanies" tt-data-id="businessco_no" tt-data-name="company_name" tt-buttons="vm.model.businessButtons"></tt-select-buttons>
        </div>

        <tt-input-buttons class="col-xs-12 sp-0" tt-label="searchtext" tt-focus="false" tt-model="vm.model.setting.searchtext" tt-on-blur="vm.onBlur('searchtext')" tt-change="vm.onChanged($value, 'searchtext')" tt-placeholder="" tt-buttons="vm.model.searchTextButtons"></tt-input-buttons>
        <tt-button class="col-xs-12 sp-0" tt-text="travexptypes_new" tt-click="vm.goToFunc('travexptype')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
    </tt-card>

    <tt-list class="col-xs-12 sp-0" list-items="vm.model.itemsListTravExpTypes" badge="" ltype="" design-var="s12t0" filter-val="vm.model.setting.searchtext"></tt-list>

    <tt-card class="col-xs-12 sp-0" ng-if="vm.model.setting.show_setting === '1'">
        <tt-button-settings class="col-xs-12 sp-0" tt-locked=""></tt-button-settings>
    </tt-card>
</tt-page>

<tt-page class="col-xs-12 sp-0" ng-if="vm.model.tabletSize.matches === true">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-page-heading class="col-xs-12 sp-0" tt-model="h_selection_criteria" tt-translate="true"></tt-page-heading>
            <div class="k-hr col-xs-12 sp-0"></div>

            <div ng-if="vm.model.setting.businessco_no === '99999'">
                <tt-select class="col-xs-12 sp-0" tt-label="businessco" tt-model="vm.model.setting.businessco_no" tt-change="vm.onChanged($value, 'businessco_no')" tt-data="vm.model.selectListCompanies" tt-data-id="businessco_no" tt-data-name="company_name"></tt-select>
            </div>

            <div ng-if="vm.model.setting.businessco_no !== '99999'">
                <tt-select-buttons class="col-xs-12 sp-0" tt-label="businessco" tt-model="vm.model.setting.businessco_no" tt-change="vm.onChanged($value, 'businessco_no')" tt-data="vm.model.selectListCompanies" tt-data-id="businessco_no" tt-data-name="company_name" tt-buttons="vm.model.businessButtons"></tt-select-buttons>
            </div>

            <tt-input-buttons class="col-xs-12 sp-0" tt-label="searchtext" tt-focus="false" tt-model="vm.model.setting.searchtext" tt-on-blur="vm.onBlur('searchtext')" tt-change="vm.onChanged($value, 'searchtext')" tt-placeholder="" tt-buttons="vm.model.searchTextButtons"></tt-input-buttons>
        </tt-card>

        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-page-heading class="col-xs-12 sp-0" tt-model="h_functions" tt-translate="true"></tt-page-heading>
            <div class="k-hr col-xs-12 sp-0"></div>
            <tt-button class="col-xs-12 sp-0" tt-text="travexptypes_new" tt-click="vm.goToFunc('travexptype')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
            <tt-button-settings ng-if="vm.model.setting.show_setting === '1'" class="col-xs-12 sp-0" tt-locked=""></tt-button-settings>
        </tt-card>
    </div>

    <tt-list class="col-xs-12 col-md-6 p-5" list-items="vm.model.itemsListTravExpTypes" badge="" ltype="" design-var="s12t0" filter-val="vm.model.setting.searchtext"></tt-list>
</tt-page>-->
